import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { AppState } from 'reducers/reducers';
import { trackPageViewed } from 'utils/analytics';
import { useOrganization } from 'contexts/OrganizationsContext';
import { TicketProvider } from 'contexts/TicketContext';
import TicketLookup from 'components/Dashboard/Modules/TicketLookup/TicketLookup';

type TicketModuleContainerProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const TicketModuleContainer = ({ profile, push }: TicketModuleContainerProps) => {
    const { organization } = useOrganization();

    useEffect(() => {
        trackPageViewed({
            pageName: 'Waive a Violation',
            organizationId: organization?.pk,
            spotId: null,
            affiliationRole: organization?.role,
            superuser: profile.superuser,
        });
    }, [profile.superuser, organization?.pk, organization?.role]);

    return (
        <TicketProvider>
            <TicketLookup connectedPush={push} />
        </TicketProvider>
    );
};

function mapStateToProps(state: AppState) {
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profile: state.auth.profile!,
    };
}

const mapDispatchToProps = {
    push,
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketModuleContainer);
